import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center w-full" }
const _hoisted_2 = {
  key: 0,
  class: "icon icon-search-ico text-32 relative z-0 -ml-8"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "path1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "path2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("input", {
      type: _ctx.inputType,
      class: _ctx.classList,
      placeholder: _ctx.$t(_ctx.placeholder),
      value: _ctx.modelValue,
      onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputChange($event)))
    }, null, 42, ["type", "placeholder", "value"]),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.showIcon)
      ? (_openBlock(), _createBlock("i", _hoisted_2, [
          _hoisted_3,
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
  ]))
}